(function() {
    'use strict';

    angular.module('eclipseApp.liveChat').controller('liveChatCtrl', ['$scope', '$http', '$stateParams', '$state', 'commonService', '$rootScope', 'uteEndpoint', 'uteLocale', 'util', '$timeout', 'uteModal', function($scope, $http, $stateParams, $state, commonService, $rootScope, uteEndpoint, uteLocale, util, $timeout, uteModal) {
        var customerFirstName = $rootScope.userInfo.firstName;
        var customerLastName = $rootScope.userInfo.lastName;
        var lang = uteLocale.language;
        var chatURL = '';
        var encryptedName = '';
        var encryptedCTN = '';
        $scope.errorOccurred = false;
        $scope.showErrorMessage = false;
        var subscriberCTN = $stateParams.subscriberCTN;
        $scope.sourceCode = '';
        $scope.blockName = 'popup';

        if(lang === 'en'){
            $scope.placeholderText = "Maximum of 500 characters";
        }
        else{
            $scope.placeholderText = "Maximum de 500 caractères";
        }



        if ($stateParams.accountNumber) {
            $rootScope.userInfo.selectedAccountNumber = $stateParams.accountNumber;
            $rootScope.userInfo.selectedSubscriberNo = '';
        } else if ((!$stateParams.accountNumber && !$rootScope.userInfo.selectedAccountNumber)) {
            $state.go('myAccount.overview');
        } else {
            if (!$stateParams.accountNumber) {
                $stateParams.accountNumber = $rootScope.userInfo.selectedAccountNumber;
            }
        }

        if($stateParams.source){
          $scope.sourceCode = $stateParams.source;
        }else if(util.getParameterByName('source')){
          $scope.sourceCode = util.getParameterByName('source');
        }
        console.log("source code:" + $scope.sourceCode);

        var accountNumber = $stateParams.accountNumber;
        var selectedAccountDetail;
        var lob;
        if (accountNumber) {
            selectedAccountDetail = _.find(commonService.accountDetails, function(accountDetail) {
                return accountDetail.accountNumber === $stateParams.accountNumber;
            });
            console.log('selectedAccountDetail', selectedAccountDetail);
        }
        $scope.payment = {};

        if (selectedAccountDetail) {
            $scope.payment = {
                accountBalance: selectedAccountDetail.balance,
                date: selectedAccountDetail.paymentDueDate,
                hasWireless: selectedAccountDetail.hasWireless,
                MOPType: selectedAccountDetail.MOPType,
                contactEmail: selectedAccountDetail.contactEmail
            };
            lob = selectedAccountDetail.LOB;
        }

        if ((!(_.isEmpty(selectedAccountDetail.subscriberServices)))) {
            for (var i = 0; i < selectedAccountDetail.subscriberServices.length; i++) {
              if (selectedAccountDetail.LOB != 'C' && selectedAccountDetail.subscriberServices[i].wireless != null && selectedAccountDetail.subscriberServices[i].wireless.subscriberNo != null) {
                subscriberCTN = selectedAccountDetail.subscriberServices[i].wireless.subscriberNo;
                break;
              }
              if (selectedAccountDetail.LOB == 'C' && selectedAccountDetail.subscriberServices[i].internet != null && selectedAccountDetail.subscriberServices[i].internet.subscriberNo != null) {
                subscriberCTN = selectedAccountDetail.subscriberServices[i].internet.subscriberNo;
                break;
              }
            }
        }
        var newChatURL = '';
        var popupBlockerChecker = {
          check: function(popup_window){
            var _scope = this;
            if (popup_window) {
              if(/chrome/.test(navigator.userAgent.toLowerCase())){
                $timeout(function () {
                  _scope._is_popup_blocked(_scope, popup_window);
                },100);
              }else{
                popup_window.onload = function () {
                  _scope._is_popup_blocked(_scope, popup_window);
                };
              }
            }else{
              _scope._displayError();
            }
          },
          _is_popup_blocked: function(scope, popup_window){
            if ((typeof popup_window != 'undefined' && popup_window.innerHeight > 0)== false) {
              scope._displayError();
            }
          },
          _displayError: function()
          {
            uteModal.open({
              templateUrl: 'modules/user/views/cookie-blocked-error-modal.html',
              windowTemplateUrl: 'views/templates/modal/pop-up-window-modal.html',
              windowClass: 'cookie-blocked-error-specific',
              controller: 'liveChatCtrl',
              backdrop: 'static',
              size: 'lg',
              ok: function () {
              },
              cancel: function () {
              }
            });
          }
        };
        $scope.submitForm = function() {
            if ($scope.liveChatForm.$valid) {
                $http({
                    method: 'POST',
                    url: uteEndpoint('v1/wireless/liveChat'),
                    data: {
                        accountNumber: accountNumber,
                        ctn: subscriberCTN,
                        fName: customerFirstName,
                        lName: customerLastName,
                        lang: lang,
                        sourceCode: $scope.sourceCode,
                        lob: lob
                    }
                }).success(function(data) {
                    console.log(data);
                    if (data.status === 'SUCCESS') {
                        $scope.responseData = data;
                        var question = $scope.question;
                        var encodedQuestion = encodeURIComponent(question);
                        $scope.encodedQuestion = encodedQuestion;
                        chatURL = $scope.responseData.chatUrl;
                        encryptedName = $scope.responseData.encryptedName;
                        encryptedCTN = $scope.responseData.encryptedCtn;
                        console.log($scope.question);
                        newChatURL = chatURL + '&a=' + encryptedName + '&b=' + encryptedCTN + '&q=' + $scope.encodedQuestion;
                        var popup = window.open(newChatURL, '_blank');
                        popupBlockerChecker.check(popup);
                    } else {
                        $scope.errorOccurred = true;
                    }
                }).error(function(data) {
                    $scope.errorOccurred = true;
                });
            }

        }

        /* $scope.init();

         var newChatURL = '';
         $scope.submitForm = function() {
             if ($scope.liveChatForm.$valid) {
                 if ($scope.errorOccurred) {
                     $scope.showErrorMessage = true;
                 } else {
                     console.log($scope.question);
                     newChatURL = chatURL + '&a=' + encryptedName + '&b=' + encryptedCTN + '&q=' + $scope.question;
                     console.log(newChatURL);
                     window.open(newChatURL, 'blank').focus();
                 }

             }
         }*/


    }]);

})();
